import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'
export default function PaidInvoiceStatus ({ invoice, invoiceProvider = null, onSendReceipt }) {
  return (
    <ul className='dropdown-menu'>
      <li>
        {
          (invoiceProvider && (invoiceProvider.toUpperCase() === 'DISPATCHER' || invoiceProvider.toUpperCase() === 'WASTEPAY')) &&
            <button
              className={styles.invoiceActionButton}
              onClick={() => onSendReceipt(invoice)}>
              <span>Send Receipt</span>
              <i className='material-icons'>send</i>
            </button>
        }
      </li>
    </ul>
  )
}
PaidInvoiceStatus.propTypes = {
  invoice: PropTypes.shape({
    client: PropTypes.object,
    id: PropTypes.string,
    lastSent: PropTypes.string,
    billTo: PropTypes.string
  }).isRequired,
  invoiceProvider: PropTypes.string,
  onSendReceipt: PropTypes.func.isRequired
}
